import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import * as moment from 'moment';
@Pipe({
  name: 'connectivitystatusdate'
})
export class ConnectivitystatusdatePipe implements PipeTransform {
  constructor( private translocoService: TranslocoService){}
  transform(value: string,isConnected:boolean, ...args: unknown[]): string {
    if(isConnected)
    {
      return this.translocoService.translate("AssetOnline");
    }
    if(!value)
    {
      return "Offline: disconnection time unknown"
    }
    const date = new Date(value);
    const dateTimeNow= new Date();
    const dateDiff =moment.duration( moment(dateTimeNow).diff(moment(new Date(value))))
    const asmin=Math.round(dateDiff.asMinutes())
    const ash=dateDiff.asHours()
    const asday=dateDiff.asDays()
    const hhmm=asmin-(Math.floor(ash)*60)
    const lcd =new Date(value).toLocaleDateString()+" at "+new Date(value).toLocaleTimeString("en-US", { hour12: true });
    if(Math.round(asday)>0)
    {
      return `Offline for more than ${Math.round(asday)} day(s) (last seen on the ${lcd})`
    }
    else if(asmin>=60)
    {
      return `Offline for ${Math.round(ash)} hour(s) and ${hhmm} minute(s) (last seen on the ${lcd})`
    }
    else if(asmin>0)
    {
      return `Offline for ${asmin} minute(s) (last seen on the ${lcd})`
    }
    return ""
  }

}
